// src/config/community.ts
/**
 * The community's Discord invite, in one place: the app's menu and the
 * public site's footer both read it. A permanent invite; if the server or
 * the landing channel changes, change it here and nowhere else.
 */
export const COMMUNITY_DISCORD_URL = 'https://discord.gg/eXGepePT97';
